import { render, staticRenderFns } from "./activerecord.vue?vue&type=template&id=e540cd52&scoped=true&"
import script from "./activerecord.vue?vue&type=script&lang=js&"
export * from "./activerecord.vue?vue&type=script&lang=js&"
import style0 from "./activerecord.vue?vue&type=style&index=0&id=e540cd52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e540cd52",
  null
  
)

export default component.exports